<template>
  <div>
    <div v-if="!loading">
      <router-view></router-view>
    </div>
    <div v-else class="flex justify-center items-center h-screen">
      carregando...
    </div>
  </div>
</template>

<script>
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/service/firebase";
import etapaCompra from "../../constants/etapaCompra";
import { loggerError } from "../../service/firebase";

export default {
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    console.log("Iniciando validação de compra_id no localStorage");
    this.validaLocalStorage();
  },
  methods: {
    async verificaExistenciaTipo(compra_id) {
      let docRef = doc(db, "compras", `${compra_id}`);
      let docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        if (docSnap.data().etapa == etapaCompra.UPLOAD) {
          this.$store.commit("compra/setCompra", docSnap.data());
          this.loading = false;
        } else {
          loggerError("compra nao esta em UPLOAD");
          localStorage.removeItem("compra_id");
          this.$router.push("/sem-autorizacao");
        }
      } else {
        loggerError("compra não existe (verificaExistenciaTipo else)");
        this.$router.push("/sem-autorizacao");
      }
    },
    validaLocalStorage() {
      this.loading = true;
      let compraID = localStorage.getItem("compra_id");
      if (compraID && compraID.length > 3) {
        this.verificaExistenciaTipo(compraID);
      } else {
        loggerError("compra_id não existe nao foi registrado no localStorage");
        this.$router.push("/sem-autorizacao");
      }
    },
  },
};
</script>
